import { useEffect } from 'react';

const SITE_NAME = 'Car PDI';
const BASE_URL = 'https://www.car-pdi.app';

const setMetaContent = (selector, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', value);
};

// Updates document title, meta description, canonical URL, and social
// preview tags per route - this is a client-side-only SPA (no SSR), so
// without this every route would keep showing the homepage's metadata.
export const usePageMeta = ({ title, description, path = '/' }) => {
  useEffect(() => {
    const fullTitle = `${title} | ${SITE_NAME}`;
    document.title = fullTitle;

    if (description) {
      setMetaContent('meta[name="description"]', description);
      setMetaContent('meta[property="og:description"]', description);
      setMetaContent('meta[name="twitter:description"]', description);
    }

    setMetaContent('meta[property="og:title"]', fullTitle);
    setMetaContent('meta[name="twitter:title"]', fullTitle);

    const canonicalUrl = `${BASE_URL}${path}`;
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) canonicalEl.setAttribute('href', canonicalUrl);
    setMetaContent('meta[property="og:url"]', canonicalUrl);
  }, [title, description, path]);
};

export default usePageMeta;
